<template>
    <v-app :dark="user.settings.darkTheme">

        <v-navigation-drawer
            stateless
            value="true"
            width="250"
            v-if="primaryDrawer.visible && loggedIn"
            v-model="primaryDrawer.model"
            :permanent="primaryDrawer.type === 'permanent'"
            :temporary="primaryDrawer.type === 'temporary'"
            :clipped="primaryDrawer.clipped"
            :floating="primaryDrawer.floating"
            :mini-variant="primaryDrawer.mini"

            fixed
            overflow
            app
            dark
        >
            <v-list class="pt-0">
                <v-tooltip
                    bottom
                    :disabled="!primaryDrawer.mini"
                >
                    <template v-slot:activator="{ on }">
                        <v-list-tile
                            v-if="!loggedIn"
                            v-on="on"
                            to="/home"
                        >
                            <v-list-tile-action>
                                <v-icon>mdi-home</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ $t("home") }}</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <span>{{ $t("home") }}</span>
                </v-tooltip>

                <v-list-group
                    v-if="loggedIn"
                    :disabled="subscription.isExpired"
                    value="true"
                    prepend-icon="mdi-margin"
                >
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-tooltip
                                bottom
                                :disabled="!primaryDrawer.mini"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-list-tile-title v-on="on">{{ $t("optimizations") }}</v-list-tile-title>
                                </template>
                                <span>{{ $t("optimizations") }}</span>
                            </v-tooltip>
                        </v-list-tile>
                    </template>


                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                :disabled="subscription.isExpired"
                                v-on="on"
                                to="/optimization"
                            >
                                <v-list-tile-action>
                                    <!-- <v-icon>mdi-vector-circle</v-icon> -->
                                    <v-icon>mdi-latitude</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("cuttingOptimization") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("cuttingOptimization") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                :disabled="subscription.isExpired"
                                v-on="on"
                                to="/diam_opt"
                            >
                                <v-list-tile-action>
                                    <v-icon>mdi-diameter-outline</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("optimalDiameter") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("findingTheOptimalDiameter") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                :disabled="subscription.isExpired"
                                v-on="on"
                                to="/cant_opt"
                            >
                                <v-list-tile-action>
                                    <v-icon>mdi-circle-double</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("cantProduction") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("cantProduction") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                :disabled="subscription.isExpired"
                                v-on="on"
                                to="/calculators"
                            >
                                <v-list-tile-action>
                                    <v-icon>mdi-calculator-variant-outline</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("calculators") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("calculators") }}</span>
                    </v-tooltip>
                </v-list-group>

                <v-tooltip
                    bottom
                    :disabled="!primaryDrawer.mini"
                >
                    <template v-slot:activator="{ on }">
                        <v-list-tile
                            :disabled="subscription.isExpired"
                            v-on="on"
                            to="/patterns"
                        >
                            <v-list-tile-action>
                                <v-icon class="left-shifted-icon">mdi-bullseye</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ $t("patternsLibrary") }}</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <span>{{ $t("patternsLibrary") }}</span>
                </v-tooltip>

                <v-tooltip
                    bottom
                    :disabled="!primaryDrawer.mini"
                >
                    <template v-slot:activator="{ on }">
                        <v-list-tile
                            :disabled="subscription.isExpired"
                            v-on="on"
                            to="/three_d"
                        >
                            <v-list-tile-action>
                                <v-icon class="left-shifted-icon">mdi-transition</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ $t("threeDLibrary") }}</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <span>{{ $t("threeDLibrary") }}</span>
                </v-tooltip>

                <v-list-group
                    v-if="loggedIn"
                    :disabled="subscription.isExpired"
                    prepend-icon="mdi-bookshelf"
                >
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-tooltip
                                bottom
                                :disabled="!primaryDrawer.mini"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-list-tile-title v-on="on">{{ $t("catalogs") }}</v-list-tile-title>
                                </template>
                                <span>{{ $t("catalogs") }}</span>
                            </v-tooltip>
                        </v-list-tile>
                    </template>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-on="on"
                                to="/species"
                            >
                                <v-list-tile-action>
                                    <v-icon class="left-shifted-icon">mdi-tree</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("species") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("species") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-on="on"
                                to="/contracts"
                                :disabled="$store.getters.subscription.settings.contracts && $store.getters.subscription.settings.contracts.lock"
                            >
                                <v-list-tile-action>
                                    <v-icon class="left-shifted-icon">mdi-invoice-list-outline</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("contracts") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("contracts") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-on="on"
                                to="/lengths"
                            >
                                <v-list-tile-action>
                                    <v-icon class="left-shifted-icon">mdi-ruler</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("lengths") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("lengths") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-on="on"
                                to="/lumber"
                            >
                                <v-list-tile-action>
                                    <v-icon class="left-shifted-icon">mdi-view-sequential</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("lumber") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("lumber") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-on="on"
                                to="/prices"
                            >
                                <v-list-tile-action>
                                    <v-icon class="left-shifted-icon">mdi-cash-100</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("prices") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("prices") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-on="on"
                                to="/volume_calc"
                                v-if="false"
                            >
                                <v-list-tile-action>
                                    <v-icon class="left-shifted-icon">mdi-square-root</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("volumeCalculationMethods") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("volumeCalculationMethods") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-on="on"
                                to="/bark"
                                v-if="false"
                            >
                                <v-list-tile-action>
                                    <v-icon class="left-shifted-icon">mdi-pine-tree</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("bark") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("bark") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-on="on"
                                to="/equipment"
                            >
                                <v-list-tile-action>
                                    <v-icon class="left-shifted-icon">mdi-saw-blade</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("equipmentProfiles") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("equipmentProfiles") }}</span>
                    </v-tooltip>

                </v-list-group>

                <v-divider v-if="loggedIn"></v-divider>

                <v-list-group
                    v-if="loggedIn && user.role > 1 "
                    :disabled="subscription.isExpired"
                    prepend-icon="mdi-cog"
                >
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-tooltip
                                bottom
                                :disabled="!primaryDrawer.mini"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-list-tile-title v-on="on">{{ $t("administration") }}</v-list-tile-title>
                                </template>
                                <span>{{ $t("administration") }}</span>
                            </v-tooltip>
                        </v-list-tile>
                    </template>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-if="loggedIn && user.role > 2 "
                                v-on="on"
                                to="/companies"
                            >
                                <v-list-tile-action>
                                    <v-icon>mdi-domain</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("companies") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("companies") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-if="loggedIn && user.role > 1 "

                                v-on="on"
                                to="/users"
                            >
                                <v-list-tile-action>
                                    <v-icon>mdi-account-multiple</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("users") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("users") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-if="loggedIn && user.role > 1 "
                                v-on="on"
                                to="/acl"
                            >
                                <v-list-tile-action>
                                    <v-icon>mdi-security</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("accessControl") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("accessControl") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-if="loggedIn && user.role > 2 "
                                v-on="on"
                                to="/limits"
                            >
                                <v-list-tile-action>
                                    <v-icon>mdi-arrow-expand-horizontal</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("limits") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("limits") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-if="loggedIn && user.role > 2 "
                                v-on="on"
                                to="/syslog"
                            >
                                <v-list-tile-action>
                                    <v-icon>mdi-view-list</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("sysLog") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("sysLog") }}</span>
                    </v-tooltip>

                    <v-tooltip
                        bottom
                        :disabled="!primaryDrawer.mini"
                    >
                        <template v-slot:activator="{ on }">
                            <v-list-tile
                                v-if="loggedIn && user.role > 2 "
                                v-on="on"
                                to="/load_test"
                            >
                                <v-list-tile-action>
                                    <v-icon>mdi-chart-areaspline-variant</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ $t("loadTesting") }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <span>{{ $t("loadTesting") }}</span>
                    </v-tooltip>
                </v-list-group>

                <v-divider v-if="loggedIn"></v-divider>

                <v-tooltip
                    bottom
                    :disabled="!primaryDrawer.mini"
                >
                    <template v-slot:activator="{ on }">
                        <v-list-tile
                            v-if="loggedIn"
                            :disabled="subscription.isExpired"
                            v-on="on"
                            to="/settings"
                        >
                            <v-list-tile-action>
                                <v-icon>mdi-tune</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ $t("settings") }}</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <span>{{ $t("settings") }}</span>
                </v-tooltip>

                <v-tooltip
                    bottom
                    :disabled="!primaryDrawer.mini"
                >
                    <template v-slot:activator="{ on }">
                        <v-list-tile
                            v-if="loggedIn"
                            v-on="on"
                            to="/account"
                        >
                            <v-list-tile-action>
                                <v-icon>mdi-account</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ $t("myAccount") }}</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <span>{{ $t("myAccount") }}</span>
                </v-tooltip>

                <v-tooltip
                    bottom
                    :disabled="!primaryDrawer.mini"
                >
                    <template v-slot:activator="{ on }">
                        <v-list-tile
                            v-if="loggedIn"
                            v-on="on"
                            to="/subscription"
                        >
                            <v-list-tile-action>
                                <v-icon>mdi-script-text-outline</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ $t("mySubscription") }}</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <span>{{ $t("mySubscription") }}</span>
                </v-tooltip>

                <v-divider v-if="loggedIn"></v-divider>

                <v-tooltip
                    bottom
                    :disabled="!primaryDrawer.mini"
                >
                    <template v-slot:activator="{ on }">
                        <v-list-tile
                            v-on="on"
                            to="/tutorials"
                        >
                            <v-list-tile-action>
                                <v-icon>mdi-youtube</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ $t("tutorials") }}</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <span>{{ $t("tutorials") }}</span>
                </v-tooltip>

                <v-tooltip
                    bottom
                    :disabled="!primaryDrawer.mini"
                >
                    <template v-slot:activator="{ on }">
                        <v-list-tile
                            v-on="on"
                            to="/support"
                        >
                            <v-list-tile-action>
                                <v-icon>mdi-face-agent</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ $t("support") }}</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <span>{{ $t("support") }}</span>
                </v-tooltip>

                <v-tooltip
                    bottom
                    :disabled="!primaryDrawer.mini"
                >
                    <template v-slot:activator="{ on }">
                        <v-list-tile
                            v-on="on"
                            to="/contacts"
                        >
                            <v-list-tile-action>
                                <v-icon>mdi-phone-in-talk</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ $t("contacts") }}</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <span>{{ $t("contacts") }}</span>
                </v-tooltip>
            </v-list>
        </v-navigation-drawer>

        <v-toolbar
            :clipped-left="primaryDrawer.clipped"
            class="teal"
            :class="{'darken-2': !this.$vuetify.dark, 'darken-4': this.$vuetify.dark}"
            app
            fixed
            dark
            dense
        >
            <v-btn
                icon
                v-if="loggedIn"
                @click.stop="toggleDrawer"
            >
                <v-icon>mdi-menu</v-icon>
            </v-btn>

            <!--
            <v-img
                v-if="$vuetify.breakpoint.mdAndUp"
                :src="require('@/assets/av.webp')"
                @click="openSite"
                class="av-logo"
                contain
            ></v-img>
            -->

            <v-img
                v-if="$vuetify.breakpoint.mdAndUp"
                :src="require('@/assets/sawmilllab.webp')"
                @click="openSite"
                class="millab-logo"
                :class="{'not-logged-in': !loggedIn}"
                contain
            ></v-img>

            <!--
            <v-toolbar-title class="headline text-uppercase">
                <div
                    v-if="$vuetify.breakpoint.mdAndUp"
                    class="font-weight-light mx-5 my-2"
                    style="overflow: hidden; text-overflow: ellipsis;"
                >{{ $t("appName") }}</div>
            </v-toolbar-title>
            -->

            <v-spacer></v-spacer>

            <v-toolbar-items>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            flat
                            :class="{'small-btn': $vuetify.breakpoint.smAndDown}"
                            v-if="!loggedIn"
                            v-on="on"
                            to="/home"
                        >
                            <v-icon>mdi-home</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t("home") }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            flat
                            :class="{'small-btn': $vuetify.breakpoint.smAndDown}"
                            v-if="!loggedIn"
                            v-on="on"
                            to="/tariffs"
                        >
                            <v-icon
                                :class="{'mr-2': $vuetify.breakpoint.lgAndUp}"
                            >mdi-credit-card-settings-outline</v-icon>
                            <span v-if="$vuetify.breakpoint.lgAndUp">{{ $t("prices") }}</span>
                        </v-btn>
                    </template>
                    <span>{{ $t("prices") }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            flat
                            :class="{'small-btn': $vuetify.breakpoint.smAndDown}"
                            v-if="!loggedIn"
                            v-on="on"
                            to="/contacts"
                        >
                            <v-icon
                                :class="{'mr-2': $vuetify.breakpoint.lgAndUp}"
                            >mdi-phone-in-talk</v-icon>
                            <span v-if="$vuetify.breakpoint.lgAndUp">{{ $t("contacts") }}</span>
                        </v-btn>
                    </template>
                    <span>{{ $t("contacts") }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            flat
                            :class="{'small-btn': $vuetify.breakpoint.smAndDown}"
                            v-if="!loggedIn"
                            v-on="on"
                            to="/tutorials"
                        >
                            <v-icon
                                :class="{'mr-2': $vuetify.breakpoint.mdAndUp}"
                            >mdi-youtube</v-icon>
                            <span v-if="$vuetify.breakpoint.lgAndUp">{{ $t("tutorials") }}</span>
                        </v-btn>
                    </template>
                    <span>{{ $t("tutorials") }}</span>
                </v-tooltip>

                <v-btn
                    flat
                    v-if="!loggedIn && !$vuetify.breakpoint.xs"
                    @click="showRegistration"
                >
                    <v-icon
                        :class="{'mr-2': $vuetify.breakpoint.smAndUp}"
                    >mdi-account-plus</v-icon>
                    <span v-if="$vuetify.breakpoint.smAndUp">{{ $t("registration") }}</span>
                </v-btn>

                <v-btn
                    flat
                    v-if="!loggedIn && !$vuetify.breakpoint.xs"
                    @click="showAuth"
                >
                    <v-icon
                        :class="{'mr-2': $vuetify.breakpoint.smAndUp}"
                    >mdi-login-variant</v-icon>
                    <span v-if="$vuetify.breakpoint.smAndUp">{{ $t("authorization") }}</span>
                </v-btn>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            small
                            absolute
                            round
                            color="warning"
                            v-if="loggedIn && subscription.id == 1 && $vuetify.breakpoint.smAndUp"
                            v-on="on"
                            class="mr-2 free-subscription-info-button"
                            @click="$router.push('/subscription')"
                        >
                            <span>{{ $t("subscriptionPlans.free").toLowerCase() }} {{ $t("subscription").toLowerCase() }}</span>
                        </v-btn>
                    </template>
                    <div
                        v-for="(text, index) in $t('freeSubscriptionInfo').split('<br>')"
                        :key="index"
                    >
                        {{ text }}
                    </div>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            flat
                            v-if="loggedIn"
                            v-on="on"
                            class="mr-2"
                            @click="showHelp"
                        >
                            <v-icon class="mr-1">mdi-help-circle</v-icon>
                            <span>{{ $t("help") }}</span>
                        </v-btn>
                    </template>
                    <span>{{ $t("help") }}</span>
                </v-tooltip>

                <v-menu
                    v-model="localeMenu"
                    v-if="!loggedIn"
                >
                    <template v-slot:activator="{ on }">
                        <v-btn flat v-on="on">
                            <flag :iso="locale.flag" :squared="false" />
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-tile
                            v-for="(lang, index) in locales"
                            :key="index"
                            @click="setLocale(lang.language)"
                        >
                            <v-list-tile-title>
                            <flag :iso="lang.flag" :squared="false" /> {{ lang.title }}
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

            <v-menu
                v-model="userMenu"
                v-if="loggedIn"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-x
            >
                <template v-slot:activator="{ on }">
                    <v-avatar
                        :size="40"
                        color="grey lighten-4"
                        v-if="loggedIn"
                        v-on="on"
                        class="c-pointer"
                    >
                        <img :src="user.avatar">
                    </v-avatar>
                </template>
                <v-card>
                    <v-list>
                        <v-list-tile avatar>
                            <v-list-tile-avatar>
                                <img :src="user.avatar" :alt="user.name">
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ user.name }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ user.company.name }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>

                    <v-divider></v-divider>

                    <v-list>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ $t("subscription") }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ subscription.title }} ({{ $t("validThrough")}} {{ subscription.expired }})</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>

                    <v-divider/>

                    <v-list>
                        <v-list-tile>
                            <v-layout>
                                <v-flex>
                                    <v-select
                                        v-model="localeDropdown"
                                        :items="locales"
                                        item-text="title"
                                        item-value="language"
                                        :label="$t('language')"
                                    >
                                        <template v-slot:selection="{ item }">
                                            <flag :iso="item.flag" :squared="false" class="mr-2" /> {{ item.title }}
                                        </template>
                                        <template v-slot:item="{ item }" >
                                            <flag :iso="item.flag" :squared="false" class="mr-2" /> {{ item.title }}
                                        </template>
                                    </v-select>
                                </v-flex>
                            </v-layout>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-switch v-model="user.settings.darkTheme" color="blue"></v-switch>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ $t("darkTheme") }}</v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile>
                            <v-list-tile-action>
                                <v-switch v-model="fullscreen" color="blue"></v-switch>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ $t("fullscreenMode") }}</v-list-tile-title>
                        </v-list-tile>

                        <v-divider></v-divider>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-list-tile
                                    v-if="loggedIn"
                                    v-on="on"
                                    @click="doLogout"
                                >
                                    <v-list-tile-action>
                                        <v-icon>mdi-logout-variant</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>{{ $t("exit") }}</v-list-tile-title>
                                </v-list-tile>
                            </template>
                            <span>{{ $t("exit") }}</span>
                        </v-tooltip>

                    </v-list>

                </v-card>
            </v-menu>
        </v-toolbar>

        <v-content>
            <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>

            <router-view
                @usersUpdated="usersUpdated"
                @userSettingsChanged="userSettingsChanged"
                @doLogout="doLogout"
                @showAuth="showAuth"
                @showRegistration="showRegistration"
                @showHelp="showHelp"
            />

            <auth-dialog  ref="AuthDialog"/>
            <help-system  ref="Help"/>
            <HTMLInfo     ref="HTMLInfo"/>
            <message-box  ref="MessageBox"/>
            <registration-dialog   ref="RegistrationDialog"/>
            <password-reset-dialog ref="PasswordReset"/>
        </v-content>

        <!--
        <v-alert
            :value="alert !== ''"
            :type="alertType"
            transition="scale-transition"
            class="bottom-alert"
        >
            {{ alert }}
        </v-alert>
        -->

        <v-alert
            v-if="cookies"
            class="cookies-message"
            :value="true"
            type="info"
            color="green"
        >
            <v-container v-if="$vuetify.breakpoint.mdAndUp">
                <v-layout row wrap>
                    <v-flex xs6 style="width: 70%">
                        <b>{{ $t("cookiesMessageFirstRow") }}</b> <br>
                        {{ $t("cookiesMessageSecondRow") }}
                    </v-flex>
                    <v-flex xs6 center>
                        <v-btn @click="confirmCookies" absolute right>
                            {{ $t("acceptCookies") }}
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container v-if="$vuetify.breakpoint.smAndDown" pl-0>
                <v-flex left mb-2 class="body-1">
                    <b>{{ $t("cookiesMessageFirstRow") }}</b> <br>
                    {{ $t("cookiesMessageSecondRow") }}
                </v-flex>
                <v-flex center mt-2>
                    <v-btn @click="confirmCookies">
                        {{ $t("acceptCookies") }}
                    </v-btn>
                </v-flex>
            </v-container>
        </v-alert>

        <v-footer v-if="!loggedIn" class="pa-3">
            <v-spacer></v-spacer>
            <a href="https://a-vektor.bitrix24.ru/~gFVwr" target="_blank" class="mr-2">{{ `${$t("privacyPolicy")}, Cookies` }}</a>
            <div>&copy; {{ $t("avtomatikaVektor") }}'{{ new Date().getFullYear() }}</div>
        </v-footer>
    </v-app>

</template>

<script>
    import AuthDialog          from "@/components/dialogs/AuthDialog";
    import HelpSystem          from "@/components/help/HelpSystem";
    import HTMLInfo            from "@/components/HTMLInfo";
    import MessageBox          from "@/components/dialogs/MessageBox";
    import PasswordResetDialog from "@/components/dialogs/PasswordResetDialog";
    import RegistrationDialog  from "@/components/dialogs/RegistrationDialog";

    //import { mapState } from "vuex";

    export default {
        name: "App",

        components: {
            AuthDialog,
            HelpSystem,
            HTMLInfo,
            MessageBox,
            PasswordResetDialog,
            RegistrationDialog,
        },

        data () {
            return {
                locale: { flag: "ru", language: "ru", title: "Русский" },
                locales: [
                    { flag: "us", language: "en", title: "English" },
                    { flag: "ru", language: "ru", title: "Русский" },
                    //{ flag: "bg", language: "bg", title: "Български (Google translate)" }
                ],
                fullscreen: false,
                //alert: "",
                //alertType: "success",
                //drawerBgImage: "img/nav-drawer-bg.jpg", // Лицензия на изображение CreativeCommons, источник: https://pxhere.com/ru/photo/1575263
                //drawerBgImage:   "img/nav-drawer-bg.png", // Лицензия на изображение CreativeCommons, источник: https://pxhere.com/ru/photo/1575263
                //darkTheme:       false,
                dialogWatcher:   null,
                checkLoginTimer: null,
                cookies:         true,
                loading: {
                    settings: false
                },
                localeMenu: false,
                localeDropdown: [],
                loggedIn: false,
                defaultSubscriptionSettings: {
                    optimization: {
                        denyExport:    true, // Запретить экспорт
                        lockCoreless:  true, // Блокировать изменение параметра использования бессердцевинной доски
                        lockCurvature: true, // Блокировать изменение параметров кривизны
                        lockWane:      true, // Блокировать изменение параметра расчёта с учётом обзола
                    },
                    lengths: {
                        lock: true, // Блокировать изменение справочника длин
                    },
                    lumber: {
                        lock: true, // Блокировать изменение справочника пиломатериалов
                    },
                    patterns: {
                        denyEdit:   true, // Запретить редактирование поставов
                        denyExport: true, // Запретить экспорт
                        denyImport: true, // Запретить импорт
                    },
                },
                subscription: {
                    id:        null,
                    title:     null,
                    expired:   null,
                    isExpired: false,
                    limits: {
                        maxUsers:    0,
                        maxPatterns: 0,
                        maxModels:   0,
                        maxLines:    0
                    },
                    settings: { ...{}, ...this.defaultSubscriptionSettings },
                },
                userMenu: false,
                user: {
                    id:       null,
                    name:     "",
                    company:  "",
                    avatar:   "img/avatar.jpg",
                    role:     1, // 1 - user, 2 - manager, 3 - admin
                    loggedIn: false,
                    settings: {
                        darkTheme:       false,
                        firstRun:        true,
                        miniDrawer:      false,
                        patternSolidBG:  false,
                        rotatePattern:   false,
                        selectedSpecies: [],
                    }
                },

                primaryDrawer: {
                    model:    null,
                    visible:  true,
                    //type:    "default (no property)",
                    type:     "permanent",
                    clipped:  true,
                    floating: false,
                    mini:     false
                },
            }
        },

        computed: {
            progressBarVisible () {
                return this.loading.settings;
            },
        },

        async mounted () {
            //this.darkTheme = localStorage.darkTheme ? JSON.parse(localStorage.darkTheme) : false;
            this.cookies = localStorage.cookies ? JSON.parse(localStorage.cookies) : true;

            /**************************** Примеры использования отладочного логгера  ****************************
            console.log("==============");
            console.log("process.env.NODE_ENV", process.env.NODE_ENV); // OUTPUT: production
            //console.log("process.env.DDD", process.env.DDD); // OUTPUT: undefined
            console.log("process.env.VUE_APP_NODE_ENV", process.env.VUE_APP_NODE_ENV); // OUTPUT: development
            console.log("==============");

            this.$debug.log("Debug log test");
            this.$debug.log(["Debug log test2", 1, [1, "2", {o: 3}], {a: 1, b: "s"}]);;
            this.$debug.error("Debug error test");
            this.$debug.warn("Debug warn test");
            this.$debug.table([
                { title: "title1", value1: "text value", value2: 1, value3: 3.2 },
                { title: "title2", value1: "text value 2", value2: 2, value3: 4.2 },
                { title: "title3", value1: "text value 3", value2: 3, value3: 5.2 },
            ], true);
            this.$debug.trace("Debug trace test");
            this.$debug.log(this.user);
            this.$debug.log("user", this.user);
            **************************** Примеры использования отладочного логгера  ****************************/

            //this.setLocale(await localStorage.currentLocale ? localStorage.currentLocale : "ru");

            if (localStorage.currentLocale) {
                this.setLocale(localStorage.currentLocale);
            } else {
                this.setLocale(
                    window.location.hostname.substring(window.location.hostname.length-3).toLowerCase() == "com"
                        ? "en"
                        : "ru"
                );
            }

            if (localStorage.hasOwnProperty("primaryDrawer")) {
                this.primaryDrawer = JSON.parse(localStorage.primaryDrawer);
            }

            let loggedIn = await this.checkLogIn()

            this.user.loggedIn = loggedIn;
            this.loggedIn      = loggedIn;

            if (loggedIn) {
                await this.getUserInfo();
                if (this.redirectIfExpired()) { return; }
                //this.redirectIfExpired();
                await this.getACL();
                await this.getSubscriptionInfo();
                await this.loadSettings();
                if (this.user.settings.firstRun != undefined && !this.user.settings.firstRun) {
                    if (this.user.settings.lastNews == undefined || this.user.settings.lastNews < this.$config.lastNews) {
                        this.user.settings.lastNews = this.$config.lastNews;

                        this.$refs.Help.showNews = true;
                        this.$refs.Help.dialog   = true;

                        this.saveUserSettings();
                    }
                }

                if (this.$router.currentRoute.path !== "/optimization") {
                    this.$router.push("/optimization");
                }

            } else {
                this.user.name    = "";
                this.user.company = { id: null, name: "" };
                this.user.role    = 1;

                this.$store.commit("setUser", this.user);

                if (this.getUrlParam().action == "pwd_reset") {
                    this.$refs.PasswordReset.step   = 2;
                    this.$refs.PasswordReset.code   = this.getUrlParam().code;
                    this.$refs.PasswordReset.dialog = true;
                } else if (this.getUrlParam().action == "pwd_confirm") {
                    let userId      = this.getUrlParam().uid;
                    let confirmCode = this.getUrlParam().code;

                    this.axios.get(
                        `${this.$config.apiURL}register/confirm/?user_id=${userId}&code=${confirmCode}`,
                        { withCredentials: true }
                    ).then(response => {
                        if (response.data.status == "success") {
                            this.showMessageBox(this.$t("information"), this.$t("accountConfirmed"));
                        } else if (response.data.status == "failure" && response.data.data !== undefined && response.data.data == "no_confirmation_code") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.noConfirmationCodeError"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("errors.accountConfirmationError"));
                        }
                    })
                    .catch(error => {
                        this.$debug.error(error);

                        this.showMessageBox(this.$t("error"), this.$t("errors.accountConfirmationError"));
                    });
                }
            }

            /* Отслеживание изменения флага авторизации в окне авторизации */
            this.$watch(
                "$refs.AuthDialog.loggedIn",
                async (val) => {
                    this.user.loggedIn = val;
                    this.loggedIn      = val;

                    if (val) {
                        await this.getUserInfo();
                        await this.getACL();
                        await this.getSubscriptionInfo();
                        await this.loadSettings();
                        if (this.redirectIfExpired()) { return; }
                        if (!this.redirectIfExpired() && this.$router.currentRoute.path !== "/optimization") {
                            this.$router.push("/optimization");
                        }

                        if (this.user.settings.firstRun == undefined || this.user.settings.firstRun) {
                            this.$refs.Help.firstRun = true;
                            this.$refs.Help.dialog   = true;

                            this.user.settings.firstRun = false;

                            this.saveUserSettings();
                        }

                        if (this.user.settings.firstRun != undefined && !this.user.settings.firstRun) {
                            if (this.user.settings.lastNews == undefined || this.user.settings.lastNews < this.$config.lastNews) {
                                this.user.settings.lastNews = this.$config.lastNews;

                                this.$refs.Help.showNews = true;
                                this.$refs.Help.dialog   = true;

                                this.saveUserSettings();
                            }
                        }
                    }
                }
            );

            /* Отслеживание изменения флага тёмной темы в окне параметров */
            this.$watch(
                "$refs.Settings.darkTheme",
                (val) => {
                    this.user.settings.darkTheme = val;
                    this.saveUserSettings();
                    //localStorage.darkTheme = this.darkTheme;
                }
            );

            this.$watch(
                "user.settings.darkTheme",
                () => {
                    this.saveUserSettings();
                }
            );

            this.startCheckLoginTimer();
        },

        watch: {
            /*
            alert: function (val) {
                let component = this;

                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },
            */

            //darkTheme:      function (val) { localStorage.darkTheme = val; },
            localeDropdown: function (val) { this.setLocale(val); },

            primaryDrawer: {
                handler: function (val) {
                    this.$store.commit("setMiniNavigationMenu", val.mini);
                },
                deep: true
            },

            // Смена полноэкранного режима
            fullscreen: function () {
                if ((document.fullScreenElement && document.fullScreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen))
                {
                    if (document.documentElement.requestFullScreen){
                        document.documentElement.requestFullScreen();
                    }
                    else if (document.documentElement.mozRequestFullScreen){ /* Firefox */
                        document.documentElement.mozRequestFullScreen();
                    }
                    else if (document.documentElement.webkitRequestFullScreen){   /* Chrome, Safari & Opera */
                        document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                    }
                    else if (document.msRequestFullscreen){ /* IE/Edge */
                        document.documentElement.msRequestFullscreen();
                    }
                }
                else
                {
                    if (document.cancelFullScreen){
                        document.cancelFullScreen();
                    }
                    else if (document.mozCancelFullScreen){ /* Firefox */
                        document.mozCancelFullScreen();
                    }
                    else if (document.webkitCancelFullScreen){   /* Chrome, Safari and Opera */
                        document.webkitCancelFullScreen();
                    }
                    else if (document.msExitFullscreen){ /* IE/Edge */
                        document.msExitFullscreen();
                    }
                }
            }
        },

        methods: {
            /**
             * Подтверждение пользователем согласия с использованием cookies
             */
            confirmCookies () {
                localStorage.cookies = false;
                this.cookies         = false;
            },

            /**
             * Проверка авторизации пользователя
             *
             * @returns {boolean}
             */
            async checkLogIn () {
                let loggedIn = false;

                await this.axios.get(`${this.$config.apiURL}login/`, { withCredentials: true })
                    .then(response => {
                        loggedIn = response.data.status == "success"
                            ? response.data.result.loggedIn
                            : false;
                    })
                    .catch(err => {
                        this.$debug.error(err);

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `App.vue -> checkLogIn: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure" && response.data.error == "captcha_api_call_failed") {
                                this.showMessageBox(this.$t("attention"), this.$t("captchaAPICallFailed"));
                            } else if (response.data.status == "failure" && response.data.error == "captcha_check_negative") {
                                this.showMessageBox(this.$t("attention"), this.$t("captchaCheckNegative"));
                            } else if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                            }
                        }).catch(error => {
                            this.$debug.error(error);

                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                            }
                        });

                        this.showMessageBox(this.$t("error"), this.$t("cantLoadLoginInfo"));
                    });
                return loggedIn;
            },

            /**
             * Расширенная проверка авторизации с сообщением если сессия прервалась по причине авторизации на другом компьютере
             */
            checkLoginExt () {
                if (this.user.loggedIn) {
                    this.axios.get(`${this.$config.apiURL}login/`, { withCredentials: true })
                        .then(response => {
                            //this.$debug.log(response);

                            if (response.data.status == "success" && !response.data.result.loggedIn && response.data.result.data == "invalidSession") {
                                clearTimeout(this.checkLoginTimer);

                                // Удаление наблюдателя если установлен
                                if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                // Отслеживание нажатия кнопки ok в диалоге
                                this.dialogWatcher = this.$watch(
                                    "$refs.MessageBox.dialog",
                                    (val) => {
                                        if (val) {
                                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                                            this.doLogout();
                                            this.startCheckLoginTimer();
                                        }
                                    }
                                );

                                this.showMessageBox(this.$t("error"), this.$t("sessionIdMismatch"));
                            }
                        })
                        .catch(err => {
                            this.$debug.error(err);

                            this.axios({
                                method: "post",
                                url: `${this.$config.apiURL}syslog/`,
                                data: {
                                    messageType: "error",
                                    messageText: `App.vue -> checkLogInExt: ${JSON.stringify(err)}`
                                },
                                withCredentials: true
                            }).then(response => {
                                if (response.data.status == "failure" && response.data.error == "captcha_api_call_failed") {
                                    this.showMessageBox(this.$t("attention"), this.$t("captchaAPICallFailed"));
                                } else if (response.data.status == "failure" && response.data.error == "captcha_check_negative") {
                                    this.showMessageBox(this.$t("attention"), this.$t("captchaCheckNegative"));
                                } else if (response.data.status == "failure") {
                                    this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                                }
                            }).catch(error => {
                                this.$debug.error(error);

                                if (error.response && error.response.status == 402) {
                                    this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                                } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                    this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                                } else if (error.response && error.response.status == 403) {
                                    this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                                }
                            });

                            // this.showMessageBox(this.$t("error"), this.$t("cantLoadLoginInfo"));
                        });
                }
            },

            /**
             * Выход из системы
             */
            doLogout () {
                this.axios.get(`${this.$config.apiURL}logout/`, { withCredentials: true })
                    .then (response => {
                        let loggedIn = response.data.status == "success"
                            ? response.data.loggedIn
                            : false;

                        if (!loggedIn) {
                            this.user.name     = "";
                            this.user.company  = { id: null, name: "" };
                            this.user.avatar   = "img/avatar.jpg";
                            this.user.role     = 1;
                            this.user.loggedIn = false;
                            this.loggedIn      = false;
                            this.user.settings = { ...this.getDefaultUserSettings() };
                            this.$store.commit("setUser", this.user);
                        }

                        this.$refs.AuthDialog.loggedIn = loggedIn;
                        this.userMenu = false;

                        if (this.$router.currentRoute.path !== "/home") {
                            this.$router.push("/home");
                        }
                    })
                    .catch (err => {
                        this.$debug.error(err);

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `App.vue -> DoLogout: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure" && response.data.error == "captcha_api_call_failed") {
                                this.showMessageBox(this.$t("attention"), this.$t("captchaAPICallFailed"));
                            } else if (response.data.status == "failure" && response.data.error == "captcha_check_negative") {
                                this.showMessageBox(this.$t("attention"), this.$t("captchaCheckNegative"));
                            } else if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                            }
                        }).catch(error => {
                            this.$debug.error(error);

                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                            }
                        });
                    });
            },

            /**
             * Получение списков контроля доступа для текущего пользователя
             *
             * @param {number} userId Идентификатор пользователя
             */
            async getACL () {
                await this.axios.get(`${this.$config.apiURL}acl/`, { withCredentials: true })
                    .then(response => {
                        this.user.acl = response.data.acl;
                    }).catch(error => {
                        this.$debug.error(error);

                        this.showMessageBox(this.$t("error"), this.$t("cantLoadACL"));
                    });
            },

            /**
             * Возвращает пользовательские настройки по умолчанию
             */
            getDefaultUserSettings () {
                return {
                    darkTheme:       false,
                    firstRun:        true,
                    miniDrawer:      false,
                    patternSolidBG:  false,
                    rotatePattern:   false,
                    selectedSpecies: [ 1, 2 ]
                };
            },

            /**
             * Возвращает параметр URL
             *
             * @param {string} url Имя параметра
             *
             * @returns {object}
             */
            getUrlParam (url) {
                // get query string from url (optional) or window
                var queryString = url ? url.split("?")[1] : window.location.search.slice(1);

                // we'll store the parameters here
                var obj = {};

                // if query string exists
                if (queryString) {

                    // stuff after # is not part of query string, so get rid of it
                    queryString = queryString.split('#')[0];

                    // split our query string into its component parts
                    var arr = queryString.split('&');

                    for (var i = 0; i < arr.length; i++) {
                        // separate the keys and the values
                        var a = arr[i].split('=');

                        // set parameter name and value (use 'true' if empty)
                        var paramName = a[0];
                        var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

                        // (optional) keep case consistent
                        paramName = paramName.toLowerCase();
                        if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

                        // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                        if (paramName.match(/\[(\d+)?\]$/)) {

                            // create key if it doesn't exist
                            var key = paramName.replace(/\[(\d+)?\]/, '');
                            if (!obj[key]) obj[key] = [];

                            // if it's an indexed array e.g. colors[2]
                            if (paramName.match(/\[\d+\]$/)) {
                                // get the index value and add the entry at the appropriate position
                                var index = /\[(\d+)\]/.exec(paramName)[1];
                            obj[key][index] = paramValue;
                            } else {
                                // otherwise add the value to the end of the array
                                obj[key].push(paramValue);
                            }
                        } else {
                            // we're dealing with a string
                            if (!obj[paramName]) {
                                // if it doesn't exist, create property
                                obj[paramName] = paramValue;
                            } else if (obj[paramName] && typeof obj[paramName] === 'string'){
                                // if property does exist and it's a string, convert it to an array
                                obj[paramName] = [obj[paramName]];
                                obj[paramName].push(paramValue);
                            } else {
                                // otherwise add the property
                                obj[paramName].push(paramValue);
                            }
                        }
                    }
                }

                return obj;
            },

            /**
             * Получение информации об авторизованном пользователе
             */
            async getUserInfo () {
                //this.$debug.log("getUserInfo");
                await this.axios.get(`${this.$config.apiURL}users/logged_in/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.user.rows == undefined) { return; }

                        let userInfo = response.data.status == "success"
                            ? response.data.user.rows[0]
                            : {};

                        userInfo.MiddleName = userInfo.MiddleName !== null
                                            ? userInfo.MiddleName.trim() + " "
                                            : "";

                        this.user.name = userInfo.FirstName.trim() + " "
                                        + userInfo.MiddleName
                                        + userInfo.LastName.trim();


                        this.subscription.id          = userInfo.Company.SubscriptionId;
                        this.subscription.expired     = new Date(userInfo.Company.ExpiredDate).toLocaleDateString();
                        this.subscription.expiredDate = userInfo.Company.ExpiredDate;

                        this.user.id = userInfo.id;
                        //this.user.companyId = userInfo.Company.id;
                        //this.user.company   = userInfo.Company.Name.trim();
                        this.user.company = {
                            id:   userInfo.Company.id,
                            name: userInfo.Company.Name.trim(),
                            settings: JSON.parse(userInfo.Company.SettingsJSON) == null
                                    ? { optiSawExportURI: "" }
                                    : JSON.parse(userInfo.Company.SettingsJSON),
                        },
                        this.user.avatar   = `${this.$config.apiURL}users/${userInfo.id}/avatar/?rand=${Math.floor(Math.random() * 1000000000)}`;
                        this.user.role     = userInfo.RoleId;
                        this.user.settings = userInfo.SettingsJSON == null || userInfo.SettingsJSON.trim() == ""
                            ? { ...this.getDefaultUserSettings() }
                            : {
                                darkTheme: JSON.parse(userInfo.SettingsJSON).darkTheme == undefined || JSON.parse(userInfo.SettingsJSON).darkTheme == null
                                    ? false
                                    : JSON.parse(userInfo.SettingsJSON).darkTheme,
                                firstRun: JSON.parse(userInfo.SettingsJSON).firstRun == undefined || JSON.parse(userInfo.SettingsJSON).firstRun == null
                                    ? true
                                    : JSON.parse(userInfo.SettingsJSON).firstRun,
                                miniDrawer: JSON.parse(userInfo.SettingsJSON).miniDrawer == undefined || JSON.parse(userInfo.SettingsJSON).miniDrawer == null
                                    ? false
                                    : JSON.parse(userInfo.SettingsJSON).miniDrawer,
                                rotatePattern: JSON.parse(userInfo.SettingsJSON).rotatePattern == undefined || JSON.parse(userInfo.SettingsJSON).rotatePattern == null
                                    ? false
                                    : JSON.parse(userInfo.SettingsJSON).rotatePattern,
                                patternSolidBG: JSON.parse(userInfo.SettingsJSON).patternSolidBG == undefined || JSON.parse(userInfo.SettingsJSON).patternSolidBG == null
                                    ? false
                                    : JSON.parse(userInfo.SettingsJSON).patternSolidBG,
                                showAxes: JSON.parse(userInfo.SettingsJSON).showAxes == undefined || JSON.parse(userInfo.SettingsJSON).showAxes == null
                                    ? true
                                    : JSON.parse(userInfo.SettingsJSON).showAxes,
                                selectedSpecies: JSON.parse(userInfo.SettingsJSON).selectedSpecies == undefined || JSON.parse(userInfo.SettingsJSON).selectedSpecies == null
                                    ? [ 1, 2 ]
                                    : JSON.parse(userInfo.SettingsJSON).selectedSpecies,
                                lastNews: JSON.parse(userInfo.SettingsJSON).lastNews == undefined || JSON.parse(userInfo.SettingsJSON).lastNews == null
                                    ? 20220101
                                    : JSON.parse(userInfo.SettingsJSON).lastNews,
                            };
                        this.primaryDrawer.mini = this.user.settings.miniDrawer;
                        this.user.loggedIn      = true;
                        this.loggedIn           = true;

                        this.$store.commit("setUser", this.user);
                    }).catch(error => {
                        this.$debug.error(error);

                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUserInfo"));
                    });
            },

            /**
             * Получение информации о подписке
             */
            async getSubscriptionInfo () {
                await this.axios.get(`${this.$config.apiURL}subscriptions/my/`, { withCredentials: true })
                    .then(response => {
                        let r_data = response.data.subscription;

                        this.subscription.title = r_data.Name;
                        this.subscription.limits = {
                            maxUsers:    r_data.MaxUsers,
                            maxPatterns: r_data.MaxPatterns,
                            maxModels:   r_data.MaxModels,
                            maxLines:    r_data.MaxLines
                        };

                        this.subscription.settings = JSON.parse(r_data.SettingsJSON) !== null
                            ? { ...this.defaultSubscriptionSettings, ...JSON.parse(r_data.SettingsJSON) }
                            : { ...this.defaultSubscriptionSettings };

                        this.$store.commit("setSubscription", this.subscription);
                    }).catch(err => {
                        this.$debug.error(err);

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `App.vue -> getSubscriptionInfo: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure" && response.data.error == "captcha_api_call_failed") {
                                this.showMessageBox(this.$t("attention"), this.$t("captchaAPICallFailed"));
                            } else if (response.data.status == "failure" && response.data.error == "captcha_check_negative") {
                                this.showMessageBox(this.$t("attention"), this.$t("captchaCheckNegative"));
                            } else if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                            }
                        }).catch(error => {
                            this.$debug.error(error);

                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                            }
                        });

                        this.showMessageBox(this.$t("error"), this.$t("cantLoadSubscriptionInfo"));
                    });
            },

            /**
             * Скрытие всех информационных блоков
             */
            hideInfoBlocks () {
                this.$refs.HTMLInfo.visible = false;
            },

            /**
             * Загрузка параметров
             */
            async loadSettings () {
                this.loading.settings = true;


                await this.axios.get(`${this.$config.apiURL}settings/param/common_settings/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let settings = response.data.settings;

                            this.$store.commit("setSettings", {
                                volCalc: {
                                    method:   settings.vol_calc && settings.vol_calc.method ? settings.vol_calc.method : "standardTables",
                                    standard: settings.vol_calc && settings.vol_calc.std    ? settings.vol_calc.std    : "gost2708_75"
                                },
                                wane: settings.wane && settings.wane.width !== undefined
                                ? settings.wane
                                : {
                                    width:                 0,
                                    cutAlongEdge:          0,
                                    cutAlongPlate:         0,
                                    maxLength:             0,
                                    wanelessCentralBoards: true,
                                },
                                report: settings.report ? settings.report
                                : {
                                    title: "",
                                    displayPrices:           true,
                                    displayPatternSizes:    true
                                },
                                lumberShrinkageCalcMethod: settings.lumber_shrinkage_calc_method ? settings.lumber_shrinkage_calc_method : "fromLogVolume",
                                lumberWaneCalcMethod: settings.lumber_wane_calc_method ? settings.lumber_wane_calc_method : "rectangle",
                                woodChipsCoef:             settings.wood_chips_coef ? settings.wood_chips_coef : 1

                            });
                        }

                        this.loading.settings = false;
                    })
                    .catch(err => {
                        this.$debug.error(err);

                        this.loading.settings = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `App.vue -> loadSettings: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure" && response.data.error == "captcha_api_call_failed") {
                                this.showMessageBox(this.$t("attention"), this.$t("captchaAPICallFailed"));
                            } else if (response.data.status == "failure" && response.data.error == "captcha_check_negative") {
                                this.showMessageBox(this.$t("attention"), this.$t("captchaCheckNegative"));
                            } else if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                            }
                        }).catch(error => {
                            this.$debug.error(error);

                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSettings") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSettings") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSettings"));
                        }
                    });
            },

            /**
             * Перенаправляет пользователя на страницу управления подпиской если она истекла
             *
             * @returns {bool}
             */
            redirectIfExpired () {
                this.subscription.isExpired = new Date(this.subscription.expiredDate) < new Date();

                let daysLeft = parseInt(((new Date(this.subscription.expiredDate)).getTime() - (new Date()).getTime()) / (1000 * 3600 * 24));

                if (daysLeft > -1 && daysLeft < 8) {
                    this.showMessageBox(this.$t("attention"), this.$t("subscriptionAlmostExpired") + " " + daysLeft);
                } else if (this.subscription.isExpired) {
                    //this.doLogout();
                    this.showMessageBox(this.$t("attention"), this.$t("subscriptionExpired"));
                    this.$router.push("/subscription");
                }

                return this.subscription.isExpired;
            },

            /**
             * Открытие сайта компании в новом окне
             */
            openSite () {
                window.open("https://www.a-vektor.ru/products/saas-versiya-programmy-optimizatsii-raspila-sawsoptimization-web/", "_blank");
            },

            /**
             * Сохранение пользовательских настроек в БД
             */
            saveUserSettings () {
                if (!this.user.loggedIn) { return; }

                this.axios({
                    method: "patch",
                    url:    `${this.$config.apiURL}users/${this.user.id}/settings/`,
                    data: {
                        settingsJSON: this.user.settings
                    },
                    withCredentials: true
                }).then(() => {
                    //this.$debug.log(response);
                    //this.showMessageBox(this.$t("information"), this.$t("userUpdated"));
                    //this.dataUpdated = true;

                    //this.alertType = "success";
                    //this.alert     = this.$t("settingsSaved");
                    this.$root.$emit("settingsSaved", true); // Рассылаем сообщение о том, что параметры сохранены.
                                                             // Нужно для того чтобы компонент, инициализировавший сохранение мог отобразить сообщение
                                                             // Если отображать в главном модуле, то сообщение будет всплывать при смене языка или изменении размера drawer
                }).catch(err => {
                    this.$debug.error(err);

                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `App.vue -> SaveUserSettings: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure" && response.data.error == "captcha_api_call_failed") {
                            this.showMessageBox(this.$t("attention"), this.$t("captchaAPICallFailed"));
                        } else if (response.data.status == "failure" && response.data.error == "captcha_check_negative") {
                            this.showMessageBox(this.$t("attention"), this.$t("captchaCheckNegative"));
                        } else if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                        }
                    }).catch(error => {
                        this.$debug.error(error);

                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                        }
                    });

                    this.showMessageBox(this.$t("error"), this.$t("errors.cantUpdateUsersSettings"));
                });
            },

            /**
             * Установка текущей локали
             *
             * @param {string} locale Код локали: en, ru и т.д.
             */
            setLocale (locale) {
                this.locales.forEach(element => {
                    if (element.language == locale) {
                        this.locale = element;
                        this.localeDropdown = locale;
                    }
                });
                this.$i18n.locale = locale;
                this.$vuetify.lang.current = locale;
                localStorage.currentLocale = locale;

                /*
                if (this.subscription.id > 0 && this.subscription.id < 7) {
                    this.subscription.title = this.$t("subscriptionLevel" + this.subscription.id);
                }
                */

                this.$root.$emit("localeChanged");
            },

            /**
             * Отображение формы авторизации
             */
            showAuth () {
                this.$refs.AuthDialog.dialog = true;
            },

            /**
             * Отображение контекстной справки
             */
            showHelp () {
                this.$refs.Help.dialog = true;
                /*
                let helpWindow = window.open("help/" + this.locale.language + this.$route.path, "_blank");
                helpWindow.focus();
                */
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Отображение формы регистрации
             */
            showRegistration () {
                //this.axios.get("data/" + this.$vuetify.lang.current + "/license.html")
                this.axios.get("/help/" + this.$vuetify.lang.current + "/eula/index.html")
                    .then(response => {
                        this.$refs.RegistrationDialog.licenseText = response.data;
                        this.$refs.RegistrationDialog.showLicense = true;
                    })
                    .catch(err => {
                        this.$debug.error(err);

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `App.vue -> ShowRegistration: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure" && response.data.error == "captcha_api_call_failed") {
                                this.showMessageBox(this.$t("attention"), this.$t("captchaAPICallFailed"));
                            } else if (response.data.status == "failure" && response.data.error == "captcha_check_negative") {
                                this.showMessageBox(this.$t("attention"), this.$t("captchaCheckNegative"));
                            } else if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                            }
                        }).catch(error => {
                            this.$debug.error(error);

                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("incorrectEMailOrPassword"));
                            }
                        });

                        this.$refs.RegistrationDialog.showLicense = false;
                    });

                this.$refs.RegistrationDialog.dialog = true;
            },

            /**
             * Запуск таймера проверки сессии
             */
            startCheckLoginTimer () {
                clearTimeout(this.checkLoginTimer);

                this.checkLoginTimer = setInterval(() => {
                    this.checkLoginExt();
                }, 30000);
            },

            /**
             * Переключение режима бокового меню
             */
            toggleDrawer () {
                if (this.$vuetify.breakpoint.smAndUp) {
                    this.primaryDrawer.visible    = true;
                    this.primaryDrawer.mini       = !this.primaryDrawer.mini;
                    this.user.settings.miniDrawer = this.primaryDrawer.mini;
                } else {
                    //this.primaryDrawer.model = !this.primaryDrawer.model;
                    this.primaryDrawer.mini    = false;
                    this.primaryDrawer.visible = !this.primaryDrawer.visible;
                }

                this.saveUserSettings();
                //localStorage.primaryDrawer = JSON.stringify(this.primaryDrawer);
            },

            /**
             * Обработчик обновления пользовательских настроек
             */
            userSettingsChanged () {
                this.user = this.$store.getters.user;
                this.saveUserSettings();
            },

            /**
             * Обработчик обновления списка пользователей
             */
            usersUpdated () {
                this.user.avatar = "img/avatar.jpg";
                this.getUserInfo();
            }
        }
    }
</script>

<style lang="sass">
    /* Общие стили */
    .cookies-message
        position: fixed
        bottom: 12px
        left: 10%
        right: 10%
        z-index: 10
        padding-top: 0
        padding-bottom: 0

    .c-pointer
        cursor: pointer
    .h-100
        height: 100%
    .w-100
        width: 100%
    .v-scroll
        overflow-y: auto
    .z-top
        z-index: 9999

    .bottom-alert
        position: fixed
        bottom: 0
        left: 0
        width: 100%
        z-index: 9999

    .progress-top
        position: absolute
        width: 100%
        top: 0
        z-index: 1

    .v-breadcrumbs.dense
        padding: 5px 12px

    .v-dialog--large
        min-height: 270px

    .border-rounded
        border-radius: 8px

    .v-carousel__prev, .v-carousel__next
        button
            color: #00695C !important

    html
        overflow: hidden !important
        scrollbar-width: none
        -ms-overflow-style: none

    .v-navigation-drawer, .v-sheet, .v-card, .v-card__text, .v-scrollable, .v-scrollable-groups, .flex
        scrollbar-width: thin

    /* Убрать кнопки вверх/вниз у цифровых полей ввода */
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button
        -webkit-appearance: none
        margin: 0

    /* Firefox */
    input[type=number]
        -moz-appearance: textfield

    /* Стили таблиц */
    $hover-box-shadow: 0 1px 2px rgba(0,0,0,0.5)
    $hover-background: #ff7
    $table-cell-padding: 0 5px

    tr.grey.darken-5
        color: #fff
        a, i
            color: #fff

    .dense-table
        &.centered-checkboxes
            .v-input--checkbox
                justify-content: center
        &.no-overflow
            .v-table__overflow
                overflow: hidden

        table.v-table
            thead
                tr
                    height: 32px
                th
                    height: 24px
                th, td
                    &:not(:nth-child(1)),
                    &:first-child
                        padding: $table-cell-padding
            tbody
                th, td
                    height: 24px
                    &:not(:nth-child(1)),
                    &:first-child
                        padding: $table-cell-padding
        .v-input__control
            .v-input__slot
                margin-bottom: 0 !important
            .v-messages
                min-height: 0

    /* Стили полей ввода и списков */
    .dense
        .v-input--selection-controls
            margin-top: 0
            .v-input__control
                .v-messages
                    min-height: 0

        ul.v-expansion-panel:last-of-type
            li:last-of-type
                margin-bottom: 10px

    /* Стили карточек */
    .v-card__text.dense
        padding: 0 16px
        .v-input__slot
            margin-bottom: 0 !important

    /* Стили поставов */
    $central-board-background: #ffda3a
    $board-background: #ffec9c
    $short-board-background: #fff6d3

    .pattern
        .thumb
            .circle
                >
                    .horizontal.container,
                    .vertical.container
                        padding: 0px
            .container.central
                .board
                    &:hover
                        background: $central-board-background
                        box-shadow: unset

            .board
                &:hover
                    background: $board-background
                    box-shadow: unset

            .board.short,
            .horizontal.board.short
                &.short:hover
                    background: $short-board-background
                    box-shadow: unset
        &.no-text-info
            .label
                display: none

    /* Стили печати */
    @media print
        @page
            size: landscape
            -webkit-transform: rotate(-90deg)
            -moz-transform: rotate(-90deg)
            transform: rotate(-90deg)
            //filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3)

        html body
            overflow: hidden
            //width: 1120px
            height: 600px

        .v-toolbar
            display: none

        .printable *
            visibility: visible !important

        .pattern-container
            width: 450px !important
            height: 450px !important

        .board, .circle
            border-color: black !important

    /* Стили App.vue */
    $box-shadow: 2px 2px 3px #555

    .av-logo
        position: absolute
        float: left
        height: 50px
        width: 50px
        margin-left: 45px
        background: #fff
        border-radius: 25px
        box-shadow: inset $box-shadow
        cursor: pointer
        transition: .5s all ease-in-out 1s

        &:hover
            box-shadow: $box-shadow

        .v-image__image
            background-position-y: -3px !important

    .millab-logo
        position: absolute
        height: 50px
        width: 166px
        /* left: 140px */
        left: 70px
        &.not-logged-in
            /* left: 100px */
            left: 20px

    .small-btn
        min-width: 60px
        width: 60px
    .free-subscription-info-button
        height: 30px !important
        right: 200px
        top: 10px

    .v-avatar
        &:hover
            box-shadow: $box-shadow

    .v-navigation-drawer
        .v-list__tile__action, .v-list__group__header__prepend-icon
            min-width: 30px !important
            padding-right: 0 !important

        .v-list__tile
            padding-right: 0 !important

    .v-navigation-drawer--mini-variant
        .left-shifted-icon
            position: absolute
            left: 30px
        .v-list__tile__action, .v-list__group__header__prepend-icon
            min-width: 80px !important
            padding-right: 0 !important
            padding-left: 0 !important
        .v-list__tile
            padding-left: 0 !important

    .application
        &.theme--dark
            a.primary--text.v-list__tile--active
                background-color: #ddd
        &.theme--light
            a.primary--text.v-list__tile--active
                background-color: #fff

    .application--wrap
        > nav.v-toolbar
            z-index: 10

    .nav-drawer-background
        position: absolute
        height: 100%
        width: 100%
        filter: brightness(30%)

    ul.filterButtons
        margin-bottom: 10px
        box-shadow: none
</style>
